import { LinkedBillingScheduleWidget } from 'Integrations/integrationsConfig/common/LinkEntities/LinkedBillingScheduleWidget/LinkedBillingScheduleWidget'
import { FC } from 'react'

export const LinkSalesforceBillingScheduleWidget: FC<{
  billingScheduleId: string
  disabled?: boolean
}> = props => (
  <LinkedBillingScheduleWidget
    billingScheduleId={props.billingScheduleId}
    service="Salesforce"
    disabled={props.disabled}
  />
)
